const typeDefs = `
  type User {
    userId: ID!
    loggedIn: Boolean!
    email: String!
    phone: String!
  }
  type Mutation {
    updateUser(userId: ID!, loggedIn: Boolean!, email: String!, phone: String!): User
  }
  type Query {
    user: User
  }
`;

export default typeDefs;



// WEBPACK FOOTER //
// ./src/resolvers/typeDefs.tsx